import { useLayoutEffect } from 'react';
export function useAutofocus(elementRef, autoFocus) {
    useLayoutEffect(() => {
        if (autoFocus) {
            ;
            elementRef.current.focus({ preventScroll: true });
        }
    }, [autoFocus]);
}
//# sourceMappingURL=useAutofocus.js.map